import React from "react";
import { Form } from "react-bootstrap";

interface DisplaySourcesCheckboxProps {
  label?: string;
  onChange?: (checked: boolean) => void;
  checked?: boolean;
}

function DisplaySourcesCheckbox({ label = "Display sources", onChange, checked }: DisplaySourcesCheckboxProps) {
  
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(event.target.checked);
      }
    };
  
    return (
      <Form>
        <Form.Check
          type="checkbox"
          label={label}
          checked={checked}
          onChange={handleChange}
          style={{color: "grey", fontSize: "0.8em"}}
        />
      </Form>
    );
}

export default DisplaySourcesCheckbox;